import ReconnectingWebSocket from 'reconnecting-websocket';
import { UrlSelectMethod } from 'types';
import { urlProvider } from './utils/apiUrlResolver';
import { wsHandlers } from './wsEventHandlers';
import { configureStore } from './store';
import { MockWebSocket } from './preview/mockWebSocket';

export const initializeWithWs = (
  apiUrl: string,
  apiUrls: string[],
  urlSelectMethod: UrlSelectMethod,
  initialState,
  previewMode: boolean,
) => {
  const ws: any = previewMode
    ? new MockWebSocket()
    : new ReconnectingWebSocket(
        apiUrls?.length
          ? async () => {
              const url = await urlProvider(store, apiUrls, urlSelectMethod);

              return url;
            }
          : apiUrl,
        [],
        {
          startClosed: true,
          maxReconnectionDelay: 1000,
          minReconnectionDelay: 1000,
          reconnectionDelayGrowFactor: 1,
        },
      );

  const store = configureStore(initialState, ws);

  ws.onopen = () => wsHandlers.onOpen(store);
  ws.onmessage = event => wsHandlers.onMessage(store, event, ws);
  ws.onerror = () => wsHandlers.onError(store, apiUrls, urlSelectMethod, ws);
  ws.onclose = () => wsHandlers.onClose(store, ws);

  return store;
};

function initializeStore({
  apiUrl,
  apiUrls,
  urlSelectMethod,
  previewMode = false,
  initialState = {},
}: {
  apiUrl: string;
  apiUrls: string[];
  urlSelectMethod: UrlSelectMethod;
  previewMode?: boolean;
  initialState?: object;
}) {
  const initialStoreState = initialState;
  const store = initializeWithWs(
    apiUrl,
    apiUrls,
    urlSelectMethod,
    initialStoreState,
    previewMode,
  );

  return store;
}

export default initializeStore;
